/* eslint-disable react/require-default-props, react/default-props-match-prop-types */
import type { ReactNode } from "react";
import React from "react";

type Props = {
  x: number;
  y: number;
  payload: {
    value: string;
  };
  textAnchor: string;
  axisStyle: {
    fill: string;
    fontSize: string | number;
  };
  colorLine: string;
  tickFormatter: (arg0: string) => string;
};

function XAxisContent({
  tickFormatter,
  axisStyle,
  x,
  y,
  payload,
  textAnchor,
  colorLine,
}: Props) {
  const circleOffset = 22;
  return (
    <>
      <circle r="2.5" fill={colorLine} cx={x} cy={y - circleOffset} />
      <text textAnchor={textAnchor} x={x} y={y} style={axisStyle}>
        {tickFormatter(payload.value)}
      </text>
    </>
  );
}

export default XAxisContent;
